import { useState } from 'react';
import { Checkbox } from 'semantic-ui-react';
import './UrlImportModal.css';

const ExtractedItemCard = ({ image, selected, suggestedName, onToggle, onNameChange }) => {
  const [name, setName] = useState(suggestedName || 'Clothing Item');
  const [imgError, setImgError] = useState(false);

  return (
    <div className={`extracted-item-card ${selected ? 'selected' : ''}`} onClick={onToggle}>
      <div className="extracted-item-checkbox">
        <Checkbox checked={selected} onChange={() => {}} />
      </div>
      <div className="extracted-item-image">
        {!imgError ? (
          <img
            src={image.url}
            alt={image.alt || name}
            onError={() => setImgError(true)}
            loading="lazy"
          />
        ) : (
          <div className="extracted-item-broken">
            <span>⚠️</span>
          </div>
        )}
      </div>
      <div className="extracted-item-info">
        <input
          className="extracted-item-name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (onNameChange) onNameChange(e.target.value);
          }}
          onClick={(e) => e.stopPropagation()}
          placeholder="Item name"
        />
        {image.source && (
          <span className="extracted-item-source">{image.source}</span>
        )}
      </div>
    </div>
  );
};

export default ExtractedItemCard;
